import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NimbusFilterSummaryBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-summary-base';

@Component({
  standalone: false,
  selector: 'nimbus-filter-summary-button',
  templateUrl: './nimbus-filter-summary-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterSummaryButtonComponent extends NimbusFilterSummaryBase {}
